import React from 'react';
import { FadeIn } from './FadeIn';
import { TrustBadges } from './TrustBadges';
import { ChevronRightIcon, CheckCircle2Icon } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-16 sm:py-24 px-4 bg-running-surface relative" data-id="element-115">
      <div className="max-w-xl mx-auto" data-id="element-116">
        <FadeIn delay={0.1} data-id="element-117">
          <div className="bg-gradient-to-b from-running-surfaceHover to-running-dark border-2 border-running-blue p-8 sm:p-10 rounded-3xl flex flex-col relative shadow-[0_0_40px_rgba(61,232,255,0.15)]" data-id="element-118">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-running-blue text-running-dark font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider whitespace-nowrap" data-id="element-119">
              Oferta de lanzamiento
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-120">
              <span className="text-3xl mb-3 block" data-id="element-121">🏃</span>
              <h3 className="text-2xl sm:text-3xl font-display font-bold text-white mb-2" data-id="element-122">
                MEGA PACK RUNNING
              </h3>
              <p className="text-gray-400" data-id="element-123">
                El sistema completo para el entrenador de running profesional.
              </p>
            </div>

            <ul className="space-y-3 mb-8 max-w-sm mx-auto w-full" data-id="element-124">
              {['6 Tomos del Sistema Principal', 'La Tríada del Cuerpo Completo (Fuerza + Nutrición + Recuperación)', 'Kit de Planificación Pro', 'Sistema de Evaluación y Seguimiento', 'Running Pro Academy (Video)', 'Mentoría y Comunidad VIP', '500+ páginas listas para usar', 'Acceso de por vida + actualizaciones'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white font-medium" data-id="element-125">
                  <CheckCircle2Icon className="w-5 h-5 text-running-blue shrink-0" data-id="element-126" />
                  <span data-id="element-127">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-8" data-id="element-128">
              <div className="text-gray-500 line-through text-lg mb-1" data-id="element-129">
                $120.000
              </div>
              <div className="text-5xl sm:text-6xl font-display font-black text-running-blue drop-shadow-[0_0_15px_rgba(61,232,255,0.3)]" data-id="element-130">
                $19.990
              </div>
              <p className="text-gray-400 text-sm mt-2" data-id="element-131">
                Precio de lanzamiento — accedé antes de que se cierre la oferta
              </p>
            </div>

            <a href="https://running-para-cambiar-vidas.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="w-full bg-running-blue hover:bg-running-blueHover text-running-dark font-display rounded-xl px-6 py-4 flex flex-col items-center justify-center transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(61,232,255,0.2)]" data-id="element-132">
              <span className="flex items-center gap-2 font-black text-xl leading-none" data-id="element-133">
                QUIERO MI PACK AHORA
                <ChevronRightIcon className="w-6 h-6" strokeWidth={3} data-id="element-134" />
              </span>
              <span className="font-bold text-sm text-running-dark/80 mt-1" data-id="element-135">
                Acceso inmediato — Garantía 7 días
              </span>
            </a>

            <div className="mt-8" data-id="element-136">
              <TrustBadges data-id="element-137" />
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}